import { SankeyLink } from '../types/sankey';

export const RTC3: SankeyLink[] = [
    {
        source: 159,
        target: 13,
        value: 1,
        valueid: ['targetaa', 'repea'],
        paperName: 'ASG21',
        process: 'ASG21_3',
        id: 'ASG21-3',
        cluster: 'rtc3',
        imgUrl: 'JY2gfvN.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 159,
        target: 18,
        value: 1,
        valueid: ['targetaa', 'repea'],
        paperName: 'ASG21',
        process: 'ASG21_3',
        id: 'ASG21-4',
        cluster: 'rtc3',
        imgUrl: 'JY2gfvN.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 13, target: 45, value: 1, valueid: ['targetaa', 'repea'], paperName: 'ASG21', process: 'ASG21_3', id: 'ASG21-14', cluster: 'rtc3', imgUrl: 'JY2gfvN.jpg', color: 'intFourLinkColor' },
    { source: 18, target: 45, value: 1, valueid: ['targetaa', 'repea'], paperName: 'ASG21', process: 'ASG21_3', id: 'ASG21-15', cluster: 'rtc3', imgUrl: 'JY2gfvN.jpg', color: 'intFourLinkColor' },
    {
        source: 13,
        target: 47,
        value: 1,
        valueid: ['targetaa', 'repea'],
        paperName: 'ASG21',
        process: 'ASG21_3',
        id: 'ASG21-16',
        cluster: 'rtc3',
        imgUrl: 'JY2gfvN.jpg',
        color: 'intFiveLightLinkColor',
    },
    {
        source: 18,
        target: 47,
        value: 1,
        valueid: ['targetaa', 'repea'],
        paperName: 'ASG21',
        process: 'ASG21_3',
        id: 'ASG21-17',
        cluster: 'rtc3',
        imgUrl: 'JY2gfvN.jpg',
        color: 'intFiveLightLinkColor',
    },
    { source: 45, target: 59, value: 1, valueid: ['targetaa', 'repea'], paperName: 'ASG21', process: 'ASG21_3', id: 'ASG21-18', cluster: 'rtc3', imgUrl: 'JY2gfvN.jpg', color: 'intFourLinkColor' },
    {
        source: 47,
        target: 59,
        value: 1,
        valueid: ['targetaa', 'repea'],
        paperName: 'ASG21',
        process: 'ASG21_3',
        id: 'ASG21-19',
        cluster: 'rtc3',
        imgUrl: 'JY2gfvN.jpg',
        color: 'intFiveLightLinkColor',
    },
    { source: 59, target: 90, value: 1, valueid: ['targetaa', 'repea'], paperName: 'ASG21', process: 'ASG21_3', id: 'ASG21-22', cluster: 'rtc3', imgUrl: 'JY2gfvN.jpg', color: 'repVisTechColor' },
    {
        source: 101,
        target: 15,
        value: 1,
        valueid: ['repb', 'targetbb'],
        paperName: 'CGK21',
        process: 'CGK21_3',
        id: 'CGK21-4',
        cluster: 'rtc3',
        imgUrl: 'Q201xEJ.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 101,
        target: 16,
        value: 1,
        valueid: ['repeb', 'targetbb'],
        paperName: 'CGK21',
        process: 'CGK21_7',
        id: 'CGK21-8',
        cluster: 'rtc3',
        imgUrl: 'Q201xEJ.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 15, target: 32, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_3', id: 'CGK21-14', cluster: 'rtc3', imgUrl: 'Q201xEJ.jpg', color: 'intOneLinkColor' },
    { source: 16, target: 41, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_7', id: 'CGK21-18', cluster: 'rtc3', imgUrl: 'Q201xEJ.jpg', color: 'intThreeLinkColor' },
    { source: 32, target: 59, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_3', id: 'CGK21-22', cluster: 'rtc3', imgUrl: 'Q201xEJ.jpg', color: 'repVisTechColor' },
    { source: 41, target: 59, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_7', id: 'CGK21-25', cluster: 'rtc3', imgUrl: 'Q201xEJ.jpg', color: 'intThreeLinkColor' },
    { source: 59, target: 95, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_3', id: 'CGK21-46', cluster: 'rtc3', imgUrl: 'Q201xEJ.jpg', color: 'repVisTechColor' },
    { source: 59, target: 95, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_7', id: 'CGK21-47', cluster: 'rtc3', imgUrl: 'Q201xEJ.jpg', color: 'repVisTechColor' },
    {
        source: 148,
        target: 9,
        value: 1,
        valueid: 'repeb',
        paperName: 'KWL09',
        process: 'KWL09_1',
        id: 'KWL09-0',
        cluster: 'rtc3',
        imgUrl: 'ukgueox.jpg',
        color: 'targetLinkOneColor',
        status: 'selected',
    },
    { source: 9, target: 36, value: 1, valueid: 'repeb', paperName: 'KWL09', process: 'KWL09_1', id: 'KWL09-2', cluster: 'rtc3', imgUrl: 'ukgueox.jpg', color: 'intOneLight3LinkColor' },
    { source: 36, target: 59, value: 1, valueid: 'repeb', paperName: 'KWL09', process: 'KWL09_1', id: 'KWL09-3', cluster: 'rtc3', imgUrl: 'ukgueox.jpg', color: 'intOneLight3LinkColor' },
    { source: 59, target: 95, value: 1, valueid: 'repeb', paperName: 'KWL09', process: 'KWL09_1', id: 'KWL09-7', cluster: 'rtc3', imgUrl: 'ukgueox.jpg', color: 'repVisTechColor' },
];
